/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/8
 */
import React from 'react';
import classNames from 'classname';

const Item = ({ name, number, isAction }) => {
  return <div className={classNames('mcycle-step-header-item', { 'mcycle-step-header-action': isAction })}>
    <div className="mcycle-step-header-radius">{number}</div>
    <p className="mcycle-step-header-name">{name}</p>
  </div>
};

export default Item;



// WEBPACK FOOTER //
// ./src/components/step/header/item.js